import { render } from "./AdminWithdrawl.vue?vue&type=template&id=fe009f74&scoped=true"
import script from "./AdminWithdrawl.vue?vue&type=script&lang=js"
export * from "./AdminWithdrawl.vue?vue&type=script&lang=js"

import "./AdminWithdrawl.vue?vue&type=style&index=0&id=fe009f74&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe009f74"]])

export default __exports__